// extracted by mini-css-extract-plugin
export default {"page-title":"button_page-title__8FI3E","container":"button_container__wEcDr"};